import React from 'react';
import { bonuses } from '../data/content';
export function BonusesSection() {
  return <section className="w-full bg-ink-800 px-4 py-14 sm:px-5 sm:py-20" data-id="element-16" data-mp="gvvli9ih9ake">
      <div className="mx-auto max-w-5xl text-center" data-id="element-17" data-mp="gxzvn96yz5t4">
        <h2 className="text-2xl font-extrabold uppercase text-white sm:text-4xl" data-id="element-18" data-mp="vtxr0p92k64a">
          🎁 Los 10 bonos estratégicos
        </h2>
        <p className="mt-3 text-xs font-extrabold uppercase tracking-[0.2em] text-brand-500" data-id="element-19" data-mp="qvw7k37qe4sa">
          Siempre incluidos
        </p>

        <ul className="mt-10 grid gap-4 text-left md:grid-cols-2 lg:grid-cols-3" data-id="element-20" data-mp="zv13r2vtlm1a">
          {bonuses.map(bonus => <li key={bonus.number} className="relative rounded-2xl border border-white/10 bg-ink-900 p-6" data-id="element-21" data-mp="1eicdcz8fyvyr">
              <span className="absolute right-5 top-5 text-2xl font-extrabold text-white/10" data-id="element-22" data-mp="19mnbuqcv34zt">
                {bonus.number}
              </span>
              <p className="text-[11px] font-extrabold uppercase tracking-widest text-brand-500" data-id="element-23" data-mp="1jj9xhhd0i02w">
                {bonus.label}
              </p>
              <h3 className="mt-3 pr-8 text-base font-extrabold text-white sm:text-lg" data-id="element-24" data-mp="3psesimbkc2ii">
                {bonus.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-gray-400" data-id="element-25" data-mp="2l2vm8kgmuhk">
                {bonus.description}
              </p>
              <p className="mt-5 flex items-center gap-2 text-sm font-bold" data-id="element-26" data-mp="7li9d18nm402">
                <span className="text-gray-500 line-through" data-id="element-27" data-mp="cklesmsjqc8k">{bonus.price}</span>
                <span className="text-brand-500" data-id="element-28" data-mp="gl5b5o5apbtn">GRATIS</span>
              </p>
            </li>)}
        </ul>

        <div className="mx-auto mt-10 max-w-xl rounded-2xl border border-brand-500/40 bg-ink-900 px-5 py-6 sm:px-6" data-id="element-29" data-mp="lbu3t6spoeud">
          <p className="text-[11px] font-extrabold uppercase tracking-[0.2em] text-gray-400" data-id="element-30" data-mp="q9vlpoeei849">
            Valor total de los 10 bonos
          </p>
          <p className="mt-3 text-xl font-extrabold text-white sm:text-3xl" data-id="element-31" data-mp="109e3by6u9ht5">
            <span className="text-gray-500 line-through" data-id="element-32" data-mp="107a0ljkoeoug">$95.000 ARS</span>{' '}
            <span className="text-brand-500" data-id="element-33" data-mp="alqrgidozhxb">→ GRATIS</span>
          </p>
          <p className="mt-1 text-sm text-gray-400" data-id="element-34" data-mp="5mxfiue1zyz9">
            con tu Sistema Despacho Total™
          </p>
        </div>
      </div>
    </section>;
}